import { useEffect, useState } from 'react'
import { useSearchEngineStore } from '../../../stores/searchStore'
import { MdOutlineAttachMoney } from 'react-icons/md'

export const MaxBudget = (): JSX.Element => {
  const { setMaxBudget, maxBudget } = useSearchEngineStore((state) => state)

  const [isFocused, setIsFocused] = useState(false)
  const [numberValue, setNumberValue] = useState(0)
  const [textValue, setTextValue] = useState('')


  const handleInputChange = (e: any): void => {
    const transform = e?.target?.value.replace(/,/g, '')

    if (!transform) {
      setNumberValue(0)
      setTextValue('')
      return
    }

    const inter = parseInt(transform)

    if (isNaN(inter)) {
      setNumberValue(0)
      setTextValue('')
      return
    }
    setNumberValue(inter)

    const parse = inter.toLocaleString('en-US', {
      maximumFractionDigits: 0
    })
    setTextValue(parse)
  }

  useEffect(() => {
    setMaxBudget(numberValue)
  }, [numberValue])

  useEffect(() => {
    if (maxBudget > 0) {
      handleInputChange({
        target: {
          value: maxBudget.toString()
        }
      })
    }
  }, [])

  useEffect(() => {
    if(maxBudget === 0) {
      setTextValue('')
    }
  },[maxBudget])

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-normal font-semibold text-[#222222]">
        ¿Cuál es tu presupuesto máximo? <span className="text-xs text-[#726E7D]">&#40;Opcional&#41;</span>
      </span>
      <div
        className={[
          'w-full h-[3.25rem] grid grid-cols-[24px,auto] items-center rounded-lg px-4 py-[0.375rem] gap-2',
          isFocused
            ? 'border-2 border-[#222]'
            : 'border border-[#CBD3E0]'
        ].join(' ')}
        onFocus={() => { setIsFocused(true) }}
        onBlur={() => { setIsFocused(false) }}
      >
        <MdOutlineAttachMoney size={24} className="fill-text-primary" />
        <input
          inputMode="numeric"
          value={textValue}
          onChange={handleInputChange}
          type="text"
          className="h-full text-base font-normal outline-none text-text-primary placeholder:text-[#898CA8] bg-transparent"
          placeholder="Precio máximo"
        />
      </div>
    </div>
  )
}

